import { useEffect, useMemo, useState } from 'react';
import { findLatestPlanningScan } from './scanTakenAt';
import type { DmScanSummary } from './types';

export interface ScanSelection {
    selectedScanId: number | null;
    selectedScan: DmScanSummary | null;
    selectScan: (scanId: number) => void;
}

// Keeps a scan selected across refetches: falls back to the latest planning scan
// (any scan if there is none) whenever the current selection leaves the list.
export function useScanSelection(scans: DmScanSummary[] | null | undefined): ScanSelection {
    const [selectedScanId, setSelectedScanId] = useState<number | null>(null);

    useEffect(() => {
        if (!scans || scans.length === 0) return;
        if (selectedScanId != null && scans.some((scan) => scan.scanId === selectedScanId)) return;
        setSelectedScanId((findLatestPlanningScan(scans) ?? scans[0]).scanId);
    }, [scans, selectedScanId]);

    const selectedScan = useMemo(
        () => scans?.find((scan) => scan.scanId === selectedScanId) ?? null,
        [scans, selectedScanId]
    );

    return { selectedScanId, selectedScan, selectScan: setSelectedScanId };
}
